<template>
  <!-- Główny kontener filtrów -->
  <div class="filters-container">
    <!-- Wybór stacji preselekcji. Lista zawiera wyłącznie stacje, które mają przypisaną grupę znaków -
         pozostałe nie miałyby czego odfiltrować. -->
    <div class="filter d-flex flex-column" v-if="filtersStore.locations.length > 1">
      <h5>
        {{ t('station') }}
        <!-- Kosz czyści filtr i przywraca wszystkie grupy. -->
        <span
          v-if="selectedLocationId"
          class="icon-trash"
          role="button"
          :title="t('vms-show-all-stations')"
          @click="clearFilter()"
        ></span>
      </h5>
      <div class="info collapse show">
        <div
          v-for="location in filtersStore.locations"
          :key="location.id"
          class="location-row"
          :class="{ 'location-row--active': location.id === selectedLocationId }"
          role="button"
          @click="setFilter(location.id)"
        >
          {{ location.shortName }}
        </div>
      </div>
    </div>

    <!-- Sekcja legendy opisującej statusy znaków -->
    <div class="filter d-flex flex-column">
      <h5>
        {{ t('legend') }}
      </h5>
      <!-- Widoczna (show) domyślnie legenda statusów -->
      <div class="info collapse show" id="legend">
        <!-- Każdy wiersz to inny status oraz jego opis -->
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-ok"></div>
          <div class="col-7 p-0">{{ t('available') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-not-ok"></div>
          <div class="col-7 p-0">{{ t('unavailable') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-error"></div>
          <div class="col-7 p-0">{{ t('malfunction') }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-1"></div>
          <div class="col-2 icons-status-on"></div>
          <div class="col-7 p-0">{{ t('enabled') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import store'ów Pinia
import { useVmsFilterStore } from "@/stores/vmsFilters";
import { useVmsStore } from "@/stores/vms";

export default {
  name: "FilterVmsData",
  setup() {
    // Inicjalizacja store Pinia dla filtrów VMS oraz store'u z danymi grup.
    const filtersStore = useVmsFilterStore();
    const vmsStore = useVmsStore();
    return { filtersStore, vmsStore };
  },
  computed: {
    /**
     * Identyfikator aktualnie wybranej stacji (filtr dopuszcza jedną naraz).
     */
    selectedLocationId() {
      return this.filtersStore.filters.locations?.[0] || null;
    },
  },
  watch: {
    // Lista stacji jest pochodną grup znaków - odświeżamy ją, gdy tylko dane grup się zmienią.
    "vmsStore.groupLocations": {
      immediate: true,
      deep: true,
      handler(groupLocations) {
        this.filtersStore.setLocationsFromGroups(groupLocations);
      },
    },
  },
  methods: {
    /**
     * Przełącza filtr stacji. Ponowne kliknięcie tej samej stacji zdejmuje filtr.
     */
    setFilter(locationId) {
      this.filtersStore.addItem("LocationList", locationId);
    },
    /**
     * Zdejmuje filtr stacji - lista pokazuje znowu wszystkie grupy.
     */
    clearFilter() {
      this.filtersStore.removeItem("locations");
    },
  },
};
</script>

<style scoped>
/* Kontener filtrów z tłem graficznym */
.filters-container {
  background: var(--surface-secondary);
}
/* Nagłówek sekcji */
.filter h5 {
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--surface-primary);
  position: relative;
  background: var(--surface-primary);
}
/* Wiersze legendy */
.row {
  height: var(--control-height);
  line-height: 25px;
}
/* Kontener z opisami statusów */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}
/* Paragrafy w legendzie */
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
}
/* Pojedyncza stacja na liście wyboru */
.location-row {
  padding: var(--spacing-sm) 0;
  cursor: pointer;
}
.location-row:hover {
  color: var(--text-primary);
}
/* Stacja, po której aktualnie filtrujemy listę grup */
.location-row--active {
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}
/* Ikona kosza czyszcząca filtr stacji */
.icon-trash {
  position: absolute;
  right: 20px;
  cursor: pointer;
}
</style>
